/// <amd-module name="Test/ManageTestPlans/Stores/NewTestPlanPageStore" />
import { Store } from "VSS/Reflux/Store";
import { NewTestPlanPageActionsHub } from "Test/ManageTestPlans/Actions/NewTestPlanPageActionsHub";
import { IFormFieldState, INode, INodeField, INewTestPlanPageState, INewTestPlanFields } from "Test/ManageTestPlans/NewTestPlanPageContracts";

export class NewTestPlanPageStore extends Store {
    public static getInstance() {
        if (!NewTestPlanPageStore._instance) {
            NewTestPlanPageStore._instance = new NewTestPlanPageStore(NewTestPlanPageActionsHub.getInstance());
        }
        return NewTestPlanPageStore._instance;
    }

    private static _instance: NewTestPlanPageStore;
    private _actionsHub: NewTestPlanPageActionsHub;

    private _isPivotLoading: boolean;
    private _areaPathNode: INode;
    private _iterationNode: INode;
    private _projectId: string;
    private _isCreatingTestPlan: boolean;
    private _errorMessage: string;
    private _areaPathMruIds: number[];
    private _iterationMruIds: number[];


    constructor(actionsHub: NewTestPlanPageActionsHub) {
        super("");

        this._isPivotLoading = true;
        this._isCreatingTestPlan = false;
        this._errorMessage = "";
        this._actionsHub = actionsHub;
        this._addListeners();
    }

    public getNewPlanState(): INewTestPlanPageState {
        if (this._isPivotLoading) {
            return {
                isLoading: true,
                nameField: {} as IFormFieldState<string>,
                rootAreaPath: {} as INodeField,
                selectedAreaPathField: {} as IFormFieldState<INodeField>,
                rootIteration: {} as INodeField,
                selectedIterationField: {} as IFormFieldState<INodeField>,
                projectId: "",
                isCreatingTestPlan: false,
                errorMessage: "",
                areaPathMruIds: [],
                iterationMruIds: []
            };
        }

        return {
            isLoading: false,
            nameField: {
                value: "",
                validationResult: { isValid: false }
            },
            rootAreaPath: {
                path: this._areaPathNode.name,
                node: this._areaPathNode
            },
            selectedAreaPathField: {
                value: {
                    path: this._areaPathNode.name,
                    node: this._areaPathNode
                },
                validationResult: { isValid: true }
            },
            rootIteration: {
                path: this._iterationNode.name,
                node: this._iterationNode
            },
            selectedIterationField: {
                value: {
                    path: this._iterationNode.name,
                    node: this._iterationNode
                },
                validationResult: { isValid: true }
            },
            projectId: this._projectId,
            isCreatingTestPlan: this._isCreatingTestPlan,
            errorMessage: this._errorMessage,
            areaPathMruIds: this._areaPathMruIds,
            iterationMruIds: this._iterationMruIds
        };
    }
    
    public get isCreatingTestPlan(): boolean {
        return this._isCreatingTestPlan;
    }

    private _addListeners(): void {
        this._actionsHub.InitializeTestPlanFields.addListener(this._handleInitializeFields);
        this._actionsHub.beginCreateTestPlan.addListener(this._handleBeginCreateTestPlan);
        this._actionsHub.createTestPlanFailed.addListener(this._handleCreateTestPlanFailed);
        this._actionsHub.createTestPlanSucceeded.addListener(this._handleCreateTestPlanSucceeded);
    }

    private _handleInitializeFields = (fields: INewTestPlanFields): void => {
        this._areaPathNode = fields.areaPath;
        this._iterationNode = fields.iteration;
        this._isPivotLoading = false;
        this._projectId = fields.projectId;
        this._areaPathMruIds = fields.areaPathMruIds;
        this._iterationMruIds = fields.iterationMruIds;

        this.emitChanged();
    }

    private _handleBeginCreateTestPlan = (): void => {
        this._isCreatingTestPlan = true;
        this.emitChanged();
    }

    private _handleCreateTestPlanFailed = (error: Error): void => {
        this._isCreatingTestPlan = false;
        this._errorMessage = error.message;

        this.emitChanged();
    }

    private _handleCreateTestPlanSucceeded = (): void => {
        this._isCreatingTestPlan = false;
        this.emitChanged();
    }
}
